<template>
  <div>
    <div
      class=""
      style="width: 100%"
      v-loading="loading"
      element-loading-text="Loading..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <div class="border-b border-black/10 !py-2">
        <h3 class="text-lg text-black-700 font-[500] !px-3 !mb-0">Payment Integrations</h3>
      </div>
      <el-row :gutter="12" class="!px-3 !mt-[1em]">
        <el-col
          class="!my-2"
          :span="6"
          v-for="(payment, index) in getActivePaymentSystems"
          :key="index"
        >
          <span @click="paymentInit(payment)" v-if="payment.status">
            <div class="grid">
              <div
                class="cardInfoDesigns cursor-pointer border rounded-md border-black/10 flex items-center px-7 py-5 justify-center"
              >
                <img class="image-fit" :src="payment.logo" :alt="payment.name" />
              </div>
            </div>
          </span>
          <span v-else>
            <div class="grid">
              <div
                class="cardInfoDesigns cursor-pointer rounded-md px-7 py-5 border border-black/10 flex items-center justify-center"
              >
                <img class="image-fit" :src="payment.logo" :alt="payment.name" />
              </div>
            </div>
          </span>
        </el-col>
      </el-row>
      <div class="clearfix"></div>
    </div>
    <dialog-component
      :title="`${paymentInfo.name} Payment Gateway Details`"
      :containerWidth="getIsMobile ? '100%' : '60vw'"
      top="6vh"
      :visible="stripeApiDialog"
      @before-close="stripeApiDialog = false"
      class="!p-0"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-position="top"
        label-width="120px"
        class="demo-ruleForm !px-[1em]"
      >
        <el-form-item prop="accountName">
          <label
            class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal block !mb-1"
          >
            <span class="text-[#EB5757]">*</span>
            Alias Name
          </label>
          <el-input v-model="ruleForm.accountName"></el-input>
        </el-form-item>
        <el-form-item prop="apiKey">
          <label
            class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal block !mb-1"
          >
            <span class="text-[#EB5757]">*</span>
            API Key
          </label>
          <el-input v-model="ruleForm.apiKey"></el-input>
        </el-form-item>
        <el-form-item prop="publicKey">
          <label
            class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal block !mb-1"
          >
            <span class="text-[#EB5757]">*</span>
            Public Key
          </label>
          <el-input v-model="ruleForm.publicKey"></el-input>
        </el-form-item>

        <!--- Forte System required Options start-->
        <el-form-item prop="orgId" v-if="paymentInfo.code === 'FORTE'">
          <label
            class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal block !mb-1"
          >
            <span class="text-[#EB5757]">*</span>
            Organization Id
          </label>
          <el-input v-model="ruleForm.otherConfigurations.orgId"></el-input>
        </el-form-item>
        <el-form-item prop="locId" v-if="paymentInfo.code === 'FORTE'">
          <label
            class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal block !mb-1"
          >
            <span class="text-[#EB5757]">*</span>
            Location Id
          </label>
          <el-input v-model="ruleForm.otherConfigurations.locId"></el-input>
        </el-form-item>
        <br />
        <el-switch
          style="display: block"
          v-model="ruleForm.isLive"
          active-color="var(--brand-500)"
          inactive-color="var(--black-200)"
          active-text="Live"
          inactive-text="Sandbox"
        ></el-switch>
        <!--- Forte System required Options end  -->

        <el-form-item class="!mt-1">
          <el-checkbox v-model="ruleForm.isDefault">Make it default payment system</el-checkbox>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="resetForm('ruleForm')">Reset</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">Integrate</el-button>
      </span>
    </dialog-component>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'SubscriptionInformation',
    components: {},
    data() {
      return {
        loading: false,
        individualPlan: {},
        businessPlan: {},
        businessProfessional: {},
        businessEssential: {},
        stripeApiDialog: false,
        paymentInfo: {},
        ruleForm: {
          stripeKey: '',
          apiKey: '',
          publicKey: '',
          isDefault: false,
          accountName: '',
          isLive: false,
          otherConfigurations: {
            orgId: '',
            locId: '',
          },
        },
        rules: {
          accountName: [
            {
              required: true,
              message: 'Please enter Alias name',
              trigger: 'blur',
            },
          ],
          stripeKey: [
            {
              required: true,
              message: 'Please enter stripe api key',
              trigger: 'blur',
            },
          ],
          apiKey: [{ required: true, message: 'Please enter api key', trigger: 'blur' }],
          publicKey: [
            {
              required: true,
              message: 'Please enter public key',
              trigger: 'blur',
            },
          ],
        },
      };
    },
    computed: {
      ...mapGetters('navigationOpen', ['getIsMobile']),
      ...mapGetters('paymentGateway', [
        'getPlansData',
        'getActivePaymentSystems',
        'getPaymentGatewayInfo',
        'getUpdateSystemInfo',
      ]),
      ...mapGetters('auth', ['getActiveWorkspace', 'getAuthenticatedUser']),
    },
    created() {},
    mounted() {
      this.getActivePaymentSystemsApi();
    },
    methods: {
      async getActivePaymentSystemsApi() {
        this.loading = true;
        await this.$store.dispatch('paymentGateway/fetchActivePaymentSystems');
        // console.log("active systems", this.getActivePaymentSystems);
        this.loading = false;
      },
      async paymentInit(info) {
        // console.log("Payment icons clicked", info);

        this.loading = true;
        await this.$store.dispatch('paymentGateway/fetchPaymentInit', {
          email: this.getAuthenticatedUser.email,
          client_id: this.getActiveWorkspace.company_id,
        });
        if (this.getPaymentGatewayInfo && this.getPaymentGatewayInfo.ivKey) {
          this.stripeApiDialog = true;
          this.paymentInfo = info;
        }
        this.loading = false;
      },

      async submitForm(formName) {
        this.$refs[formName].validate(async (valid) => {
          if (valid) {
            const keys = this.$CryptoJS.AES.encrypt(
              JSON.stringify(this.ruleForm),
              this.getPaymentGatewayInfo.ivKey
            ).toString();
            let requestInfo = {
              pgType: this.paymentInfo.code,
              type: 'APP',
              status: 'ACTIVE',
              crypto: keys,
              accountName: this.ruleForm.accountName,
              isDefault: this.ruleForm.isDefault,
            };
            const data = this.$CryptoJS.AES.encrypt(
              JSON.stringify(requestInfo),
              this.getPaymentGatewayInfo.ivKey
            ).toString();
            requestInfo.pg_account_id = this.getPaymentGatewayInfo._id;
            requestInfo.ivKey = this.getPaymentGatewayInfo.ivKey;
            // requestInfo.accountName= this.ruleForm.accountName;

            this.loading = true;
            await this.$store.dispatch('paymentGateway/updateSystemInfoById', {
              info: requestInfo,
              accountId: this.getPaymentGatewayInfo._id,
              data: data,
            });

            if (this.getUpdateSystemInfo) {
              this.$notify({
                title: 'Success',
                message: `${this.paymentInfo.name} integrated.`,
                type: 'success',
              });
              this.$router.push({
                path: `/${
                  this.getActiveWorkspace.company_id
                }/configuration/paymentSystems?_t=${Date.now()}`,
              });
            }
            this.stripeApiDialog = false;
            this.paymentInfo = {};
            this.ruleForm = {
              stripeKey: '',
              apiKey: '',
              publicKey: '',
              isDefault: false,
              accountName: '',
              isLive: false,
              otherConfigurations: {
                orgId: '',
                locId: '',
              },
            };
            this.loading = false;
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
    },
  };
</script>
<style lang="scss" scoped>
  .cropper {
    height: 600px;
    width: 600px;
    background: #ddd;
  }

  .paymentSty {
    cursor: pointer;
  }

  .image-fit {
    height: 2rem;
  }

  .clearfix {
    padding-bottom: 2rem;
  }

  .cardInfoBlock {
    cursor: no-drop;
    border: 1px solid #80808094;
  }

  .el-card__body {
    padding: 1rem !important;
  }

  .cardInfoDesigns {
    width: 100%;
    height: 2rem;
    text-align: center;
  }
</style>
